import styled from "styled-components";
import CompanyInfoModal from "./component";

export default styled(CompanyInfoModal)``;
